import Swiper, { Scrollbar, A11y, Mousewheel, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";

Swiper.use([Scrollbar, A11y, Mousewheel, Navigation]);

if (document.querySelector(".products-swiper")) {
    document.querySelectorAll(".products-swiper").forEach((slider) => {
        let breakpoints = {
            1280: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 3,
            },
            600: {
                slidesPerView: 2,
            },
            300: {
                slidesPerView: 2,
            },
        };
        let spv = 4;

        new Swiper(slider, {
            allowTouchMove: true,
            slidesPerView: spv,
            spaceBetween: 25,
            wrapperClass: "products",
            slideClass: "product",
            scrollbar: {
                el: ".swiper-scrollbar",
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            breakpoints: breakpoints,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            a11y: {
                prevSlideMessage: "Föregående bild",
                nextSlideMessage: "Nästa bild",
            },
        });

        slider.querySelectorAll(".swiper-button").forEach((button) => {
            button.style.display = "flex";
        });
    });
}
